<div class="p-4">
  <div class="modal-header">
    <h2 class="modal-title title text-capitalize"
        data-automation-id="edit-list-name-modal-title"
        id="edit-list-name-modal-title"
        translate>
      listEditNameModalTitle
    </h2>
    <button (click)="onClose()"
            [attr.aria-label]="'closeDialog' | translate"
            class="close-btn p-0 m-n2"
            data-automation-id="edit-list-name-modal-close-btn"
            type="button">
      <span aria-hidden="true" class="icon icon-close"></span>
    </button>
  </div>

  <div class="modal-body">
    <form (ngSubmit)="onSubmit()"
          [formGroup]="editListNameForm"
          data-automation-id="edit-list-name-modal-form">
      <div class="form-group">
        <input [attr.aria-invalid]="name.invalid && name.touched"
               [class.is-invalid]="name.invalid && name.touched"
               aria-labelledby="edit-list-name-modal-title"
               aria-required="true"
               class="form-control edit-list-name-form-name"
               data-automation-id="edit-list-name-modal-form-name"
               formControlName="name"
               placeholder="{{ 'listEditNamePlaceholder' | translate }}"
               type="text"/>
        <div aria-atomic="true" aria-live="assertive" role="alert">
          <p *ngIf="editListNameForm.invalid && editListNameForm.touched"
             class="invalid-feedback d-block"
             data-automation-id="edit-list-name-modal-form-error">
            <ng-container *ngIf="editListNameForm.errors?.unknown">
              {{ 'generalServerError' | translate }}
            </ng-container>

            <ng-container *ngIf="name.errors">
              <ng-container *ngIf="name.errors.required">
                {{ 'listEditNameRequiredError' | translate }}
              </ng-container>
              <ng-container *ngIf="name.errors.maxlength">
                {{ 'listEditNameMaxLengthError' | translate: {maxCharactersNumber: name.errors.maxlength.requiredLength} }}
              </ng-container>
              <ng-container *ngIf="name.errors.duplicate">
                {{ 'listEditNameDuplicateError' | translate }}
              </ng-container>
            </ng-container>
          </p>
        </div>
      </div>
    </form>
    <div aria-live="polite" role="status">
      <div *ngIf="isUpdating"
           class="spinner-border text-primary"
           data-automation-id="edit-list-name-modal-spinner">
        <span class="sr-only" translate>Loading...</span>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-start">
    <button (click)="onSubmit()"
            class="ins-buttons button-primary flint"
            data-automation-id="edit-list-name-modal-confirm-btn"
            translate
            type="button">
      listEditNameSaveButton
    </button>
    <button (click)="onClose()"
            class="ins-buttons button-secondary flint ml-3 text-uppercase"
            data-automation-id="edit-list-name-modal-cancel-btn"
            translate>
      listEditNameCancelButton
    </button>
  </div>
</div>
